module.exports = __webpack_public_path__ + "img/product2_11B984_age.69f4decd.png";